// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SectionTitle, { SectionTitleFields } from "@werner/App/Components/Common/SectionTitle";
import React, { FC } from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const SectionContainer: FC<Props> = ({ fields, id }) => {
    return (
        <>
            <SectionTitle
                title={fields.title}
                viewMoreLink={fields.viewMoreLink}
                viewMoreText={fields.viewMoreText}
                border={fields.border}
            />
            <Zone contentId={id} zoneName="Content0" />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: SectionContainer,
    definition: {
        group: "Xngage Custom" as any,
        fieldDefinitions: [...SectionTitleFields],
    },
};

export default widgetModule;
